import Subscribers from 'collections/Subscribers';
import GroupMembership from 'entities/GroupMembership';
import Collection from 'lib/Collection';

class GroupMemberships extends Collection<GroupMembership> {
  initialize() {
    this.url = '/members';
    // @ts-expect-error ts-migrate(2740) FIXME: Type 'typeof GroupMembership' is missing the follo... Remove this comment to see the full error message
    this.model = GroupMembership;
  }

  comparator = (a: GroupMembership, b: GroupMembership): number => {
    const nameA = a.getUser().getFirstName();
    const nameB = b.getUser().getFirstName();
    return nameA.localeCompare(nameB);
  };

  sortByFirstName() {
    return this.sortBy((member) => {
      const user = member.getUser();
      return `${user.getFirstName()} ${user.getLastName()}`.toLowerCase();
    });
  }

  sortByLastName() {
    return this.sortBy((member) => {
      const user = member.getUser();
      return `${user.getLastName()}, ${user.getFirstName()}`.toLowerCase();
    });
  }

  sortByCreatedAt() {
    return this.sortBy((member) => -member.getCreatedAt());
  }

  sortByOrganizationRole() {
    return this.sortBy((member) => {
      const orgAffView = member.getOrgAffiliationView();
      return orgAffView ? orgAffView.roles.join(',') : '';
    });
  }

  groupByRole() {
    const members = this.groupBy('role');
    const s: GroupMemberships | GroupMembership[] = members['owner'] || [];
    return new GroupMemberships(s.concat(members['subscriber'] || []), {
      sort: false,
    });
  }

  getSubscribers() {
    return new Subscribers(this.map((member) => member.getUser()));
  }
}

export default GroupMemberships;
